// export default class Config  {
//     ip = 'http://192.168.0.7:2707/'
// };

export const SERVER_ = `${window.location.protocol}//${window.location.hostname}:2808/`
